module.exports = __webpack_public_path__ + "img/000651b.webp";